import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Tabs, Row, Col, Button, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

const { TabPane } = Tabs

const DiscountTabs = (props: any) => {
  const { codes, automatic, loyalty } = props
  const history = useHistory()
  const location = useLocation()

  const getActiveKey = () => {
    if (location.pathname === '/discounts') return 'manual'
    const pathArray = location.pathname.split('/')
    return pathArray[pathArray.length - 1]
  }

  const handleTabChange = (key: string) => {
    history.push(`/discounts/${key}`)
  }

  return (
    <>
      <Row justify='end' className='_w-100'>
        <Col>
          <Link to={'/discounts/create'}>
            <Button icon={<PlusOutlined />}>Add Discount</Button>
          </Link>
        </Col>
      </Row>
      <Tabs
        type='card'
        activeKey={getActiveKey()}
        onChange={handleTabChange}
        className='_mb-8'
      >
        <TabPane
          key='manual'
          tab={
            <Tooltip
              title={
                <span>
                  <a
                    href='https://support.slerp.com/knowledge/creating-and-managing-discount-codes'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Here's our best practise guide
                  </a>{' '}
                  to creating and managing discount codes.
                </span>
              }
            >
              <span data-testid='discount-codes-tab-pane'>
                Manual Discounts
              </span>
            </Tooltip>
          }
        >
          {codes}
        </TabPane>

        <TabPane
          key='automatic'
          tab={
            <span data-testid='automatic-discounts-tab-pane'>
              Automatic Discounts
            </span>
          }
        >
          {automatic}
        </TabPane>

        <TabPane
          key='rewards'
          tab={
            <span data-testid='loyalty-rewards-tab-pane'>Loyalty Rewards</span>
          }
        >
          {loyalty}
        </TabPane>
      </Tabs>
    </>
  )
}

export default DiscountTabs
